// extracted by mini-css-extract-plugin
module.exports = {"authPage":"Auth_authPage__2Cvtx","authPage_link":"Auth_authPage_link__UGLaq","authPage_modal":"Auth_authPage_modal__CxHKt"};